import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Planificación Express 12 Meses',
    desc: 'El año de Sociales organizado por mes para primaria en 10 minutos',
    val: '$8.000'
  }, {
    num: '02',
    title: '30 Clases Salvavidas de Sociales',
    desc: 'Para cuando no tenés nada listo: abrís una ficha y la clase funciona',
    val: '$10.000'
  }, {
    num: '03',
    title: 'Banco de Evaluaciones Listo',
    desc: '12 rúbricas completas + 20 instrumentos de evaluación rápidos',
    val: '$7.000'
  }, {
    num: '04',
    title: 'Kit de Efemérides Argentinas',
    desc: '25 mayo, 9 julio, Malvinas, Día de la Memoria + guías de actividades listas',
    val: '$9.000'
  }, {
    num: '05',
    title: 'Banco de Mapas y Recursos Visuales',
    desc: '40 recursos visuales de geografía e historia argentina listos para imprimir',
    val: '$6.000'
  }, {
    num: '06',
    title: 'Sistema de Gestión Docente',
    desc: 'Registro de notas, asistencia, portfolio del alumno y comunicación con familias',
    val: '$12.000'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-17">
            MÁS LOS 6 BONOS{' '}
            <span className="text-brand-accent" data-id="element-18">ESTRATÉGICOS</span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-19">
            Incluidos en tu oferta — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 md:p-8 border border-brand-border relative overflow-hidden flex flex-col" data-id="element-21">
              <div className="text-7xl font-heading font-black text-brand-accent/10 absolute top-2 right-4 leading-none" aria-hidden="true" data-id="element-22">
                {bonus.num}
              </div>
              <div className="relative z-10 flex-grow flex flex-col" data-id="element-23">
                <div className="text-brand-accent font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-24">
                  BONO #{bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-4 pr-8 leading-tight" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-8 text-sm leading-relaxed flex-grow" data-id="element-26">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-5 border-t border-brand-border mt-auto" data-id="element-27">
                  <div className="text-white/70 line-through text-sm" data-id="element-28">
                    Valor {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1.5 rounded-full uppercase tracking-wider" data-id="element-29">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-30">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-31">
            🎁 Valor total de los 6 Bonos:{' '}
            <span className="line-through text-white/50" data-id="element-32">$52.000</span> → GRATIS
          </h3>
          <p className="text-white/70 font-medium" data-id="element-33">Solo por hoy</p>
        </div>
      </div>
    </section>;
}